import { useState } from 'react';
import Edit from '@mui/icons-material/Edit';
import {IconButton} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Add from "@mui/icons-material/Add";
import { API_BASE_URL} from "../baseURL";

const Multiplicator = ({ multiplicator, setMultiplicator }) => {
    const [showEditMultiplicatorModal, setShowEditMultiplicatorModal] = useState(false);
    const [showAddMultiplicatorModal, setShowAddMultiplicatorModal] = useState(false);
    const [modaldata, setModaldata] = useState('');

    function saveNewMnote(date, comment) {
        fetch(`${API_BASE_URL}/multiplicators/${multiplicator.id}/mnotes/create-mnote`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
            body: JSON.stringify({ mnoteId: 0, date: date, comment: comment, user: '' })
        }).then(response => response.json())
            .then(data =>  {
                multiplicator.mnotes.push(data);
                multiplicator.mnotes.sort((a, b) => new Date(b.date) - new Date(a.date));
                setMultiplicator(multiplicator);
            })
    }

    function saveNewComment(mnoteId, newComment) {
        const id = parseInt(mnoteId);

        fetch(`${API_BASE_URL}/multiplicators/mnotes/${id}/update-comment`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
            body: newComment
        }).then()

        multiplicator.mnotes.find(mnote => mnote.id === id).comment = newComment;
        setMultiplicator(multiplicator);
    }

    function deleteMnote(mnoteId) {
        const id1 = parseInt(multiplicator.id);
        const id2 = parseInt(mnoteId);

        fetch(`${API_BASE_URL}/multiplicators/${id1}/mnotes/${id2}/delete`, {
            method: "DELETE",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
        }).then();

        multiplicator.mnotes.forEach((mnote, index) => {
            if(mnote.id === mnoteId) {
                multiplicator.mnotes.splice(index, 1);
            }
        })

        setMultiplicator({...multiplicator})
    }

    return (
        <>
            { multiplicator ? (
                <div>
                    <IconButton>
                        <Add fontSize="inherit" className="custom-btn-add" onClick={() => {
                            setShowAddMultiplicatorModal(true);
                            // setModaldata(farmer.id);
                        }} />
                    </IconButton>

                    <table className="inner-table">
                        <thead >
                            <tr >
                                <th style={{width:"10%", paddingLeft: "20px"}}>Datum</th>
                                <th style={{width:"10%"}}>Benutzer</th>
                                <th style={{width:"65%"}}>Notiz</th>
                                <th style={{width:"15%"}}></th>
                            </tr>
                        </thead>
                        <tbody>
                            { multiplicator.mnotes && multiplicator.mnotes.map((mnote, index) => (
                                <tr key={index} id="rowId" value={mnote.id}>
                                    <td>{new Date(mnote.date).toLocaleDateString('sv-SE')}</td>
                                    <td>{mnote.user}</td>
                                    <td>{mnote.comment}</td>
                                    <td className="actions">
                                        {/*<IconButton>
                                            { mnote.changeable ?
                                                <Edit className="custom-btn-edit"
                                                      onClick={() => {
                                                          setShowEditMultiplicatorModal(true);
                                                          setModaldata(mnote);
                                                      }} /> : <Edit className="custom-btn-edit" style={{color: "grey"}} disabled/>
                                            }
                                        </IconButton>
                                        <IconButton>
                                            { mnote.changeable ?
                                                <DeleteIcon className="custom-btn-delete" onClick={() => { if(window.confirm("Wirklich entfernen?")) {deleteMnote(mnote.id)} }} /> :
                                                <DeleteIcon className="custom-btn-delete" style={{color: "grey"}} disabled/>
                                            }
                                        </IconButton>*/}
                                        <IconButton>
                                            <Edit className="custom-btn-edit"
                                                  onClick={() => {
                                                      setShowEditMultiplicatorModal(true);
                                                      setModaldata(mnote); }} />
                                        </IconButton>
                                        <IconButton>
                                            <DeleteIcon className="custom-btn-delete" onClick={() => { if(window.confirm("Wirklich entfernen?")) {deleteMnote(mnote.id)} }} />
                                        </IconButton>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* displays edit modal  */}
                    { showEditMultiplicatorModal ? (
                        <div className="custom-modal">
                            <div className="custom-modal-dialog">
                                <div>
                                    <button onClick={() => setShowEditMultiplicatorModal(false)} style={{ float: "right" }}> &times; </button>
                                    {/*<h4>Nr. : {modaldata.id}</h4>*/}
                                </div>

                                <div style={{marginTop:"20px"}}>
                                    <input id="mnoteId" value={modaldata.id} hidden />
                                    <p>
                                        <b>Datum:</b> {new Date(modaldata.date).toISOString().split('T')[0]}
                                    </p>
                                    <textarea id="textarea" style={{width:"100%", height:"100px"}}>
                                        {modaldata.comment}
                                    </textarea>
                                </div>

                                <div style={{marginTop: "20px"}}>
                                    <button onClick={() => { setShowEditMultiplicatorModal(false) }} className="custom-btn-close" > Schließen </button>
                                    <button
                                        onClick={() => {
                                            setShowEditMultiplicatorModal(false)
                                            saveNewComment(document.getElementById("mnoteId").value, document.getElementById("textarea").value)
                                        }
                                        }
                                        className="custom-btn-save" > Speichern </button>
                                </div>
                            </div>
                        </div>
                    ) : null }

                    {/* displays add modal  */}
                    { showAddMultiplicatorModal ? (
                        <div className="custom-modal">
                            <div className="custom-modal-dialog">
                                {/*<div className="modal-header">
                                    <h4>Nr. : {modaldata.id}</h4>
                                </div>*/}
                                <div className="custom-modal-body">
                                    {/*<input id="farmerId" value={modaldata} hidden />*/}
                                    <div>
                                        <label><b>Datum:</b></label>
                                        <br/>
                                        <input type="date" id="date" style={{width:"25%"}} />
                                    </div>
                                    <br/>
                                    <div>
                                        <label><b>Notiz:</b></label>
                                        <textarea id="comment" style={{width:"100%", height:"100px"}}></textarea>
                                    </div>
                                </div>
                                <div style={{marginTop: "20px"}}>
                                    <button onClick={() => { setShowAddMultiplicatorModal(false); }} className="custom-btn-close" > Schließen </button>
                                    <button
                                        onClick={() => {
                                            setShowAddMultiplicatorModal(false)
                                            saveNewMnote(document.getElementById("date").value, document.getElementById("comment").value)
                                            }
                                        }
                                        className="custom-btn-save" style={{marginLeft:"20px"}} > Speichern </button>
                                </div>
                            </div>
                        </div>
                    ) : null }
                </div>
            ) : null }
        </>
    );
}

export default Multiplicator;
